import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Checkbox, FormControlLabel, Grid, Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useFormikContext } from 'formik';
import { ClientDto } from '../../api/apiClients';
import { useAppDispatch, useAppSelector } from '../../store';
import { sendPdsEmailAsync, downloadPdsAsync } from '../../store/clientApplication';
import { Colors, SubtitleText, ErrorMessage, LoadingAnimation, DialogBox } from '../controls/helpers';

const DownloadPds = () => {
  const { client, pdsDownloading, pdsDownloaded, pdsEmailSending, pdsEmailSent } = useAppSelector(state => state.clientApplication);
  const { clientId } = useParams<{ clientId: string }>();
  const dispatch = useAppDispatch();
  const [openConfirm, setOpenConfirm] = useState(false);
  const { setFieldValue, values } = useFormikContext<ClientDto & { consented: boolean }>();
  const isSingleProduct = (values?.kiwiSaverApplication?.active && !values?.wealthBuilderApplications?.some(a => a.active === true) && !values?.incomeGeneratorApplications?.some(a => a.active === true)) //KS only
    || (!values?.kiwiSaverApplication?.active && values?.wealthBuilderApplications?.some(a => a.active === true) && !values?.incomeGeneratorApplications?.some(a => a.active === true)) //WB only
    || (!values?.kiwiSaverApplication?.active && !values?.wealthBuilderApplications?.some(a => a.active === true) && values?.incomeGeneratorApplications?.some(a => a.active === true)); //IG only

  useEffect(() => {
    if (!pdsEmailSent) return;
    setOpenConfirm(!pdsEmailSending && pdsEmailSent ? true : false);
  }, [pdsEmailSending, pdsEmailSent]);

  return <Grid container spacing={3}>
    <Grid item xs={12}>
      <SubtitleText hideMarginBottom>Please download a copy of the NZ Funds Product Disclosure Statement{!isSingleProduct ? 's' : ''}.</SubtitleText>
    </Grid>
    <Grid item xs={12}>
      <Grid container justifyContent="space-between" spacing={3}>
        <Grid item sm={4} xs={12}>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            disabled={pdsDownloading}
            startIcon={<>&emsp;</>}
            endIcon={pdsDownloading ? <LoadingAnimation size={16} /> : <>&emsp;</>}
            onClick={() => dispatch(downloadPdsAsync({
              includeKiwiSaver: values?.kiwiSaverApplication?.active === true,
              includeWealthBuilder: values?.wealthBuilderApplications?.some(a => a.active) === true,
              includeIncomeGenerator: values?.incomeGeneratorApplications?.some(a => a.active) === true
            }))}>
            Download
          </Button>
        </Grid>
        {client?.sendEmail === true &&
          <Grid item sm='auto' xs={12}>
            <Button
              fullWidth
              color="default"
              variant="contained"
              disabled={pdsEmailSending}
              startIcon={<>&emsp;</>}
              endIcon={pdsEmailSending ? <LoadingAnimation size={16} /> : <>&emsp;</>}
              onClick={() => dispatch(sendPdsEmailAsync({
                token: clientId,
                kiwiSaver: values?.kiwiSaverApplication?.active === true,
                wealthBuilder: values?.wealthBuilderApplications?.some(a => a.active === true) === true,
                incomeGenerator: values?.incomeGeneratorApplications?.some(a => a.active === true) === true
              }))}>
              Help - I cannot download this
            </Button>
          </Grid>
        }
      </Grid>
    </Grid>
    {pdsDownloaded &&
      <Grid item xs={12}>
        <Alert severity="success">The Product Disclosure Statement{!isSingleProduct ? 's have' : ' has'} been downloaded.</Alert>
      </Grid>
    }
    <Grid item xs={12}>
      <FormControlLabel
        disabled={!pdsDownloaded && !pdsEmailSent}
        labelPlacement="end"
        label={<SubtitleText hideMarginBottom black={pdsDownloaded || pdsEmailSent}>I confirm that:</SubtitleText>}
        control={<Checkbox color="primary" checked={values.consented} onChange={(_, checked) => { setFieldValue('consented', checked); setFieldValue('pdsDownloaded', checked); }} />}
      />
      <SubtitleText hideMarginBottom black={pdsDownloaded || pdsEmailSent}>
        <ul style={{ marginTop: 0 }}>
          <li>I have read the Product Disclosure Statement{!isSingleProduct ? 's' : ''}, including NZ Funds' approach to privacy, client declarations & consents.</li>
          <li>The information in this application is correct.</li>
        </ul>
      </SubtitleText>
      <ErrorMessage name="pdsDownloaded" />
    </Grid>
    <DialogBox icon={<CheckCircleIcon htmlColor={Colors.Green} />} open={openConfirm} onClose={() => setOpenConfirm(false)}>
      <Box p={2}>
        <SubtitleText black>We have emailed you a copy of the Product Disclosure Statement{!isSingleProduct ? 's' : ''}.</SubtitleText>
      </Box>
      <Box p={2}>
        <Button color="primary" variant="contained" type="submit" style={{ float: 'right' }} onClick={() => setOpenConfirm(false)} key="btnOk">OK</Button>
      </Box>
    </DialogBox>
  </Grid>
}

export default DownloadPds;
